// extracted by mini-css-extract-plugin
export default {"coachPagesWrap":"CoachPageLayout_coachPagesWrap__cqgAT","coachContent":"CoachPageLayout_coachContent__XrKwk"};